import { Service } from '../annotations';

const DEFAULT_TRANSITION_DURATION: number = 500;

@Service('ScrollService')
export class ScrollService {
	public scrollToElement(selector: string, duration: number = DEFAULT_TRANSITION_DURATION): void {
		let elementTop: number = $(selector).offset().top;
		$('html, body').animate({scrollTop: elementTop}, duration);
	}
}


/** WEBPACK FOOTER **
 ** ./app/common/scroll-service.ts
 **/